import { deleteWidgetFromLayout } from "api/Dashboard";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";

export const useDeleteWidgetFromLayout = () => {
    const queryClient = useQueryClient();

    return useMutation(deleteWidgetFromLayout, {
        onSuccess: () => {
            toast.success('Deleted Successfully')
            queryClient.invalidateQueries('dashboardLayout');

        },
        onError: (error: any) => {
            toast.error(error.response.data.error || 'Something went wrong')
        }
    });
};
